import { createFileRoute } from '@tanstack/react-router'

import { DigitalProductStore } from '@/features/store'
import {
  validateStoreSheetSearch,
  type StoreSheetSearch
} from '@/features/store/lib/storeSheetSearch'

export const Route = createFileRoute('/_event/lojinha/')({
  validateSearch: (search: Record<string, unknown>): StoreSheetSearch =>
    validateStoreSheetSearch(search),
  component: DigitalProductStorePage
})

function DigitalProductStorePage() {
  const sheetSearch = Route.useSearch()

  return <DigitalProductStore sheetSearch={sheetSearch} />
}
